import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import FormatCrypto from "@hl/base-components/lib/FormatCrypto";
import { Text } from "@mantine/core";
const MarketplacePrice = ({ price, decimals, ...rest }) => {
    var _a, _b, _c;
    return (_jsx(Text, { ...rest, children: _jsx(FormatCrypto, { sx: { whiteSpace: "nowrap" }, onlyText: true, decimals: decimals || ((_a = price === null || price === void 0 ? void 0 : price.currency) === null || _a === void 0 ? void 0 : _a.decimals), amount: (_b = price === null || price === void 0 ? void 0 : price.amount) === null || _b === void 0 ? void 0 : _b.raw, symbol: (_c = price === null || price === void 0 ? void 0 : price.currency) === null || _c === void 0 ? void 0 : _c.symbol }) }));
};
export default MarketplacePrice;
